<div class="host-syn-task-list">
  <div class="top">
    <nz-button-group>
      <button
        nz-button
        [nzType]="taskType ? 'default' : 'primary'"
        (click)="chooseAllTask()"
      >
        <!-- 全部任务 -->
        {{ "syn_task.all_task" | translate }}
      </button>
      <button
        nz-button
        [nzType]="taskType ? 'primary' : 'default'"
        (click)="chooseFailedTask()"
      >
        <!-- 失败任务 -->
        {{ "syn_task.failed_task" | translate }}
      </button>
    </nz-button-group>
  </div>
  <nz-spin [nzSpinning]="loading">
    <div class="lists" *ngIf="taskList.length > 0">
      <div class="list" *ngFor="let task of taskList">
        <div class="list-container">
          <div class="basic">
            <div class="info">
              <div class="title">
                <div class="circle" [style.background]="task.color"></div>
                <p>{{ task?.house_title }}</p>
              </div>
              <div class="time">
                {{ task?.create_time | dateformat }}
              </div>
              <div class="status-cotainer">
                <div class="status" [style.background]="task?.color">
                  {{ task?.status }}
                </div>
              </div>
            </div>
            <div class="message">
              <div class="thirdparty">
                {{ "word.channel_" + task?.thirdparty_type | translate }}
              </div>
              <div class="time-range" *ngIf="task.task_type !== 2">
                {{ task?.begin | dateformat: ["MD"] }} ~
                {{ task?.end | dateformat: ["MD"] }}
              </div>
              <div
                class="change"
                *ngFor="let item of task?.change"
                [ngSwitch]="item?.type"
              >
                <div class="change-bold" *ngSwitchCase="'house_price'">
                  <!-- 价格 -->
                  {{ "component.syn_task.price" | translate }}
                </div>
                <div class="change-bold" *ngSwitchCase="'house_inventory'">
                  <!-- 库存 -->
                  {{ "component.syn_task.reserve" | translate }}
                </div>
                <div class="change-bold" *ngSwitchCase="'house_status'">
                  <!-- 房态 -->
                  {{ "component.syn_task.availability" | translate }}
                </div>
                <div class="change-bold" *ngSwitchCase="'daily_price'">
                  <!-- 基础价格 -->
                  {{ "component.syn_task.basic_price" | translate }}
                </div>
                <div class="change-bold" *ngSwitchCase="'weekend_price'">
                  <!-- 周末价格 -->
                  {{ "component.syn_task.weekend_price" | translate }}
                </div>
                <div
                  style="padding-left: 5px"
                  *ngIf="item?.from !== null"
                  [innerHTML]="
                    'syn_task.change_from_to'
                      | translate: { from: item?.from, to: item?.to }
                      | html
                  "
                ></div>
                <div
                  style="padding-left: 5px"
                  *ngIf="item?.from === null"
                  [innerHTML]="
                    'syn_task.change_to' | translate: { to: item?.to } | html
                  "
                ></div>
                <!-- <p class="change-light" *ngIf="item?.from !== null">
                  从
                </p>
                <div
                  class="change-bold"
                  *ngIf="item?.from !== null">
                  {{ item?.from }}
                </div>
                <p
                  class="change-light"
                  *ngIf="item?.to !== null">
                  改为
                </p>
                <div
                  class="change-bold"
                  *ngIf="item?.to !== null">
                  {{ item?.to }}
                </div> -->
              </div>
              <div class="change-light">
                <span [innerHTML]="'word.open_parenthesis' | translate"></span
                >{{ task?.task_reason
                }}<span
                  [innerHTML]="'word.close_parenthesis' | translate"
                ></span>
              </div>
            </div>
            <div class="error" *ngIf="task?.failed_message">
              <div class="fail">
                <!-- 失败原因： -->
                {{ "word.fail_reason" | translate }}
                {{ task?.failed_message }}
              </div>
            </div>
          </div>
          <div class="operate">
            <span *ngIf="task?.sync_status === 3" (click)="retry(task)">
              <!-- 重试 -->
              {{ "word.retry" | translate }}
            </span>
            <span (click)="toHouseStatusDetail(task)">
              <!-- 查看详情 -->
              {{ "word.view_details" | translate }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="none" *ngIf="taskList.length === 0">
      <img class="host-no-data-img-small" src="/assets/icon/no_data.png" />
      <p class="title">
        <!-- 暂无数据 -->
        {{ "word.no_data" | translate }}
      </p>
    </div>
  </nz-spin>
  <div class="pagination">
    <nz-pagination
      [(nzPageIndex)]="pageIndex"
      [nzTotal]="total"
      [nzPageSize]="20"
      (nzPageIndexChange)="pageChange()"
    ></nz-pagination>
  </div>
</div>
